import React from 'react';
import { Link } from 'react-router-dom';
import { Handshake, Mail } from 'lucide-react';

const SPONSORS = [
  { name: 'KPMG', logo: '/media/uploads/2017/04/KMPG-logo-300x129.png' },
  { name: 'PwC', logo: '/media/uploads/2019/04/Screen-Shot-2019-04-06-at-2.09.20-PM.png' },
  { name: 'Deloitte', logo: '/media/sponsors/deloitte.jpg' },
  { name: 'RBC', logo: '/media/sponsors/rbc.jpg' },
  { name: 'Mourant', logo: '/media/sponsors/mourant.webp' },
  { name: 'Cayman Islands Olympic Committee', logo: '/media/sponsors/cioc.jpg' },
  { name: 'Ministry of Youth, Sports, Culture & Heritage', logo: '/media/sponsors/ministry-youth-sports.png' },
  { name: 'Ministry of Education & Training', logo: '/media/sponsors/ministry-education.jpg' },
];

const OTHER_SPONSORS = ['Vistra'];

export default function SponsorsPage() {
  return (
    <div className="static-page">
      <div className="page-hero">
        <div className="container">
          <span className="page-hero-label">Our Partners</span>
          <h1>Sponsors</h1>
          <p>The organizations whose generous support makes basketball possible for over 1,500 athletes across the Cayman Islands.</p>
        </div>
      </div>

      <div className="container section">
        <div className="sponsor-grid">
          {SPONSORS.map((s) => (
            <div key={s.name} className="sponsor-card">
              <div className="sponsor-logo">
                <img src={s.logo} alt={`${s.name} logo`} loading="lazy" />
              </div>
              <div className="sponsor-info">
                <h3>{s.name}</h3>
              </div>
            </div>
          ))}
        </div>

        <div className="sponsor-others">
          <h2 className="section-title">Also Proudly Supported By</h2>
          <div className="sponsor-others-list">
            {OTHER_SPONSORS.map((o) => (
              <span key={o} className="sponsor-other-chip"><Handshake size={15} /> {o}</span>
            ))}
          </div>
        </div>

        <div className="sponsor-cta">
          <div>
            <h2>Become a Sponsor</h2>
            <p>Partner with CIBA and help positively impact lives through basketball — from grassroots leagues to national teams on the international stage.</p>
          </div>
          <Link to="/contact-us" className="btn-primary"><Mail size={16} /> Get In Touch</Link>
        </div>
      </div>
    </div>
  );
}
